import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import Logo from "../images/logo1.png";
import Placeholder from "../images/placeholder.jpg";

import layout from "../css/landing.module.css";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../css/members.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHouse,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

function Updatemember() {
  const { church_id } = useParams();
  const navigate = useNavigate();

  const [updatedInfo, setUpdatedMember] = useState({});
  const [imagePreview, setImagePreview] = useState(Placeholder);

  // ================= FETCH MEMBER =================
  useEffect(() => {
    fetch(
      `https://appserver.cemkharistemple.com/updatemember/${church_id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setUpdatedMember(data);
      })
      .catch((err) => console.error(err));
  }, [church_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedMember((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        `https://appserver.cemkharistemple.com/updatemember/${church_id}`,
        { value: updatedInfo }
      );

      if (res.data.message === "Success") {
        alert("Details Updated Successfully");
        navigate("/kharispage");
      } else {
        alert("Update failed");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  if (!updatedInfo) return <div>Loading...</div>;

  return (
    <div className={layout.container}>
      {/* HEADER */}
      <Topbar title="Update Member" subtitle="Edit member information" />

      {/* SIDEBAR */}
      <Sidebar variant="kharis" />

      {/* MAIN */}
      <main className={layout.main}>
        <div className={styles.wrapper}>
          <form onSubmit={handleUpdate} className={styles.formCard}>

            {/* TOP ROW */}
            <div className={styles.topRow}>
              <div className={styles.leftTop}>
                <input
                  type="text"
                  value={updatedInfo.church_id}
                  readOnly
                  className={styles.input}
                />
              </div>

              <div className={styles.profileSection}>
                <img
                  src={imagePreview}
                  alt="Preview"
                  className={styles.profilePreview}
                />
                <input
                  type="file"
                  onChange={handleImageChange}
                  className={styles.uploadInput}
                />
              </div>
            </div>

            {/* PERSONAL */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Personal Information</div>
              <div className={styles.formGrid}>
                <input name="first_name" value={updatedInfo.first_name || ""} placeholder="First Name" className={styles.input} onChange={handleChange} />
                <input name="last_name" value={updatedInfo.last_name || ""} placeholder="Last Name" className={styles.input} onChange={handleChange} />
                <input name="other_name" value={updatedInfo.other_name || ""} placeholder="Other Name" className={styles.input} onChange={handleChange} />
                <input name="mobile_num" value={updatedInfo.mobile_num || ""} placeholder="Mobile Number" className={styles.input} onChange={handleChange} />
                <input name="area" value={updatedInfo.area || ""} placeholder="Area" className={styles.input} onChange={handleChange} />
                <input name="housenum" value={updatedInfo.housenum || ""} placeholder="House Number" className={styles.input} onChange={handleChange} />
                <input name="landmark" value={updatedInfo.landmark || ""} placeholder="Nearest Landmark" className={styles.input} onChange={handleChange} />
                <input name="digital_add" value={updatedInfo.digital_add || ""} placeholder="Digital Address" className={styles.input} onChange={handleChange} />
                <input name="hometown" value={updatedInfo.hometown || ""} placeholder="Hometown" className={styles.input} onChange={handleChange} />
                <input name="region" value={updatedInfo.region || ""} placeholder="Region" className={styles.input} onChange={handleChange} />
                <input name="pbox" value={updatedInfo.pbox || ""} placeholder="Mailing Address" className={styles.input} onChange={handleChange} />
                <input name="email" value={updatedInfo.email || ""} placeholder="Email" className={styles.input} onChange={handleChange} />
                <input name="dob" value={updatedInfo.dob || ""} placeholder="Date of Birth" className={styles.input} onChange={handleChange} />
              </div>
            </div>

            {/* EMPLOYMENT */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Employment Information</div>
              <div className={styles.formGrid}>
                <input name="occupation" value={updatedInfo.occupation || ""} placeholder="Occupation" className={styles.input} onChange={handleChange} />
                <input name="employer" value={updatedInfo.employer || ""} placeholder="Employer" className={styles.input} onChange={handleChange} />
                <input name="work_address" value={updatedInfo.work_address || ""} placeholder="Work Address" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
                <input name="work_contact_num" value={updatedInfo.work_contact_num || ""} placeholder="Work Contact Number" className={styles.input} onChange={handleChange} />
                <input name="office_location" value={updatedInfo.office_location || ""} placeholder="Office Location" className={styles.input} onChange={handleChange} />
              </div>
            </div>

            {/* FAMILY */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Family Information</div>
              <div className={styles.formGrid}>
                <input name="marital_status" value={updatedInfo.marital_status || ""} placeholder="Marital Status" className={styles.input} onChange={handleChange} />
                <input name="marriage_type" value={updatedInfo.marriage_type || ""} placeholder="Marriage Type" className={styles.input} onChange={handleChange} />
                <input name="spouse_name" value={updatedInfo.spouse_name || ""} placeholder="Spouse Name" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
                <input name="children" value={updatedInfo.children || ""} placeholder="Children" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
              </div>
            </div>

            {/* DEPARTMENT */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Department & Others</div>
              <div className={styles.formGrid}>
                <input name="department" value={updatedInfo.department || ""} placeholder="Department" className={styles.input} onChange={handleChange} />
                <input name="service_type" value={updatedInfo.service_type || ""} placeholder="Service Type" className={styles.input} onChange={handleChange} />
                <input name="date_joined" value={updatedInfo.date_joined || ""} placeholder="Date Joined" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
              </div>
            </div>

            {/* ACTIONS */}
            <div className={styles.formActions}>
              <button type="submit" className={styles.primaryBtn}>
                Update Member
              </button>
              <button
                type="button"
                className={styles.secondaryBtn}
                onClick={() => navigate("/kharispage")}
              >
                Cancel
              </button>
            </div>

          </form>
        </div>
      </main>
    </div>
  );
}

export default Updatemember;